import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomOktaAuthService } from './oktaauth.service';

@Injectable()
export class IAMRoleGuard implements CanActivate {

    constructor(private okta: CustomOktaAuthService, private router: Router) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        const authenticated = await this.okta.isIAMAuthorized();

        // console.log("auth guard authenticated: ", authenticated);
        if (authenticated) { return true; }

        // login flow
        this.okta.login();

        return false;
    }
}
